import { setCookie } from 'cookies-next';
import type { IncomingMessage, ServerResponse } from 'node:http';

import { USER_UUID_COOKIE_NAME } from '@/utils/constants/common';

import generateUUID from '../generateUUID';

export const USER_UUID_COOKIE_EXPIRATION_DAYS = 90;

type SetUserUUIDCookieOptions = {
    req?: IncomingMessage;
    res?: ServerResponse;
};

/**
 * Create anonymous user id cookie. Pass `{ req, res }` when called server-side —
 * cookies-next needs both to write a Set-Cookie response header; without them it
 * silently no-ops server-side instead of falling back to `document.cookie`.
 * @returns {string} anonymous user id
 */
export const setUserUUIDCookie = ({ req, res }: SetUserUUIDCookieOptions = {}) => {
    const userId = generateUUID();
    const date = new Date();
    date.setDate(date.getDate() + USER_UUID_COOKIE_EXPIRATION_DAYS);

    setCookie(USER_UUID_COOKIE_NAME, userId, {
        expires: date,
        path: '/',
        ...(req && res ? { req, res } : {}),
    });

    return userId;
};
